import React, { useState } from "react";
import "./Tabs.css"; // Add your CSS styles for the tabs

interface TabsProps {
  tabs: string[]; // Array of tab labels
  trackName: string;
  onTabSelect: (index: number) => void; // Callback to notify parent of selected tab index
}

const Tabs: React.FC<TabsProps> = ({ tabs, trackName, onTabSelect }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveIndex(index);
    onTabSelect(index); // Notify parent of selected tab index
  };

  return (
    <div className="tabs-container">
      <div className="listen-wav-title">{trackName}</div>
      <div>
        <div />
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${activeIndex === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
